export default {
  headers: {
    'Content-type': 'application/json',
    'Accept': 'application/json'
  },

  get: function (options) {
    let promise
    let headers = Object.assign(this.headers, options.headers)

    promise = fetch(options.url, {
      method: 'GET',
      headers: new Headers(headers)
    })

    return promise.then(function (response) {
      if (!response.ok) {
        return Promise.reject(response.json().then(function (data) {
          throw Error(data.msg)
        }))
      } else {
        return response.json()
      }
    }).catch(function (error) {
      return error
    })
  },

  post: function (options) {
    let promise
    let headers = (options.ignoreDefaultHeaders) ? Object.assign({}, options.headers) : Object.assign(this.headers, options.headers)

    promise = fetch(options.url, {
      body: JSON.stringify(options.data),
      method: 'POST',
      headers: new Headers(headers)
    })

    return promise.then(function (response) {
      if (!response.ok) {
        return Promise.reject(response.json().then(function (data) {
          throw Error(data.msg)
        }))
      } else {
        return response.json()
      }
    }).catch(function (error) {
      return error
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/services/service-manager.js